import agentRegion from '@/agent/components/agentregion/agent-region.vue';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtArticle from '@/common/components/mvtarticle/mvt-article.vue';
import mvtListLinks from '@/common/components/mvtlistlinks/mvt-listlinks.vue';
import mvtPageMenu from '@/common/components/mvtpagemenu/mvt-pagemenu.vue';
import mapper from '@/common/store/mapper/index.js';
import sitemapBreadcrumb from '@/sitemap/components/sitemapbreadcrumb/sitemap-breadcrumb.vue';
import sitemapPropertyTypes from '@/sitemap/components/sitemappropertytypes/sitemap-propertytypes.vue';
import sitemapWelcome from '@/sitemap/components/sitemapwelcome/sitemap-welcome.vue';
import { mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtCollapsibleLinks from '@/common/components/mvtcollapsiblelinks/mvt-collapsiblelinks.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtListProperty from '@/common/components/mvtlistproperty/mvt-listproperty.vue';
import mvtPagination from '@/common/components/mvtpagination/mvt-pagination.vue';

export default {
    name: 'pageSitemap',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        sitemapWelcome,
        sitemapPropertyTypes,
        mvtArticle,
        mvtCollapsibleLinks,
        sitemapBreadcrumb,
        agentRegion,
        mvtListLinks,
        mvtPageMenu,
        mvtHeader,
        mvtFooter,
        mvtListProperty,
        mvtPagination,
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        ...mapGetters('sitemap', ['geo']),
        sitemap() {
            return this.glb.pageData || {};
        },
        getMenuType() {
            if (this.sitemap.isAgent || this.sitemap.isRental || this.sitemap.pageType === 'vsitemap_states') {
                return this.sitemap.isAgent ? 'Agents' : this.sitemap.isRental ? 'Rentals' : 'Listings';
            }
            return '';
        },
        getImgSrc() {
            let src;
            if (this.sitemap.isRental) {
                src = this.sitemap.bannerUrl || this.sitemap.bannerUrlWebp;
            } else {
                src = `${this.glb.cdnUrl}${this.sitemap.isAgent ? 'images/desktop/agent-customer.webp' : 'images/desktop/customer.webp'}`;
            }
            return src;
        },
        letterLinkList() {
            if (this.sitemap.listingCountByLetter) {
                const letterObj = this.sitemap.listingCountByLetter;
                const appUrl = this.glb.appUrl.replace(/\/$/, '');
                const sitemapUrl = this.glb.url.split('?')[0];
                const url = sitemapUrl.indexOf('letter-') !== -1 ? sitemapUrl.replace(/letter-([a-z])\//, '') : sitemapUrl;
                return Object.keys(letterObj).map((v) => {
                    return {
                        letter: v,
                        countAvailable: letterObj[v],
                        sitemapUrl: `${appUrl}${url}letter-${v.toLowerCase()}/`,
                    };
                });
            } else {
                return null;
            }
        },
        listingData() {
            if (this.sitemap.nearByListings) {
                const result = this.sitemap.nearByListings.map((listing) => {
                    return mapper.property(listing, this.glb);
                });
                return result;
            } else {
                return null;
            }
        },
        getBreadCrumbData() {
            return this.sitemap.breadCrumb;
        },
        isBanner() {
            return this.sitemap.bannerUrl || this.sitemap.bannerUrlWebp;
        },
        getPageMenuList() {
            return this.sitemap.pageMenuList;
        },
        hideRealEstateLinks() {
            return ['vsitemap_city', 'vsitemap_countycities', 'vsitemap_state', 'vsitemap_staterent', 'vsitemap_countynew'].includes(this.sitemap.pageType);
        },
        getSitemapLinks() {
            if (this.sitemap.isNewSitemapReorg) {
                return [{ url: `${this.glb.appUrl}sitemap/rentals/`, text: 'Rentals' }];
            }
            return [
                { url: this.glb.appUrl + 'market-trends/', text: 'Market Trends' },
                { url: this.glb.appUrl + 'schools/', text: 'Schools' },
                { url: this.glb.appUrl + 'sitemap/rentals/', text: 'Rentals' },
                { url: this.glb.appUrl + 'sitemap/home-values/', text: 'Public Records' },
            ];
        },
        baseUrl() {
            let currentPath = this.$route.path.replace(/^\//, '');
            currentPath = currentPath.replace(/\/p-\d+\/?/i, '/');
            return `${this.glb.appUrl}${currentPath}`;
        },
        pageDisplayLimit() {
            return this.glb.isPhone ? 3 : 5;
        },
        pageCount() {
            return this.sitemap.pages.length - 2;
        },
        isNewSitemapTemplate() {
            return this.sitemap.isNewSitemapReorg && this.sitemap.dataList.some(list => list.isMain || list.isAside);
        },
    },
    methods: {
        formatDataList(listData) {
            if(this.isNewSitemapTemplate) {
                return listData;
            }
            if (listData?.length > 0) {
                const items = listData.map((link) => {
                    const list = [];
                    if (link.type === 'COUNTY') {
                        const parts = [];
                        parts.push({
                            url: `${this.glb.appUrl}${link.nameForUrl}`,
                            text: `${link.displayName}${link.listingCount ? ` <span class="f7">(${link.listingCount})</span>` : ''}`,
                        });
                        !['vsitemap_countynew', 'vsitemap_staterent', 'vsitemap_countycities'].includes(this.sitemap.pageType) &&
                            parts.push({
                                url: `${this.glb.appUrl}${link.sitemapCountyPageUrl}`,
                                text: `${link.displayName} homes for sale`,
                            });
                        list.push({
                            multipart: true,
                            parts,
                        });
                    } else if (link.newNameForUrl || link.luxuryHomesUrl) {
                        const parts = [];
                        parts.push({
                            url: `${this.glb.appUrl}${link.nameForUrl}`,
                            text: `${link.displayName}${link.listingCount ? ` <span class="f7">(${link.listingCount})</span>` : ''}`,
                        });
                        if (link.newNameForUrl) {
                            parts.push({
                                url: `${this.glb.appUrl}${link.nameForUrl}`,
                                text: '<span class="f7">(New)</span>',
                            });
                        }
                        if (link.luxuryHomesUrl) {
                            parts.push({
                                url: `${this.glb.appUrl}${link.luxuryHomesUrl}`,
                                text: '<span class="f7">(Luxury)</span>',
                            });
                        }
                        list.push({
                            multipart: true,
                            parts,
                        });
                    } else {
                        list.push({
                            url: `${this.glb.appUrl}${link.nameForUrl}`,
                            text: `${link.displayName}${link.listingCount ? ` <span class="f7">(${link.listingCount})</span>` : ''}`,
                        });
                    }
                    if (this.sitemap.pageType === 'vsitemap_countycities') {
                        list.push({
                            url: `${this.glb.appUrl}${!link.nameForUrl.includes('sitemap/') ? 'sitemap/' : ''}${
                                link.nameForUrl.includes('dallas-tx') ? link.nameForUrl.replace('homes-for-sale/', '') : link.nameForUrl
                            }`,
                            text: `${link.name} zip codes & neighborhoods`,
                        });
                    }

                    return list.length > 1 ? list : list[0];
                });
                return items;
            }
            return [];
        },
        isValidUrl(url) {
            return url && !url.includes('undefined');
        }
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
